import { render, staticRenderFns } from "./CreditUserDetailsDialogMoreRestaurants.vue?vue&type=template&id=17d6ed17"
import script from "./CreditUserDetailsDialogMoreRestaurants.vue?vue&type=script&lang=js"
export * from "./CreditUserDetailsDialogMoreRestaurants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports